export const environment = {
    appName: "ABARAN_SCHEME_ADMIN",
    production: false,
    apiUrl: 'https://abaran-bengaluru-api.uat-demo.com/',
    apiPrefix: 'api/v1',
    media_domain: 'https://d2kjby4l6ivee0.cloudfront.net/scheme-app/development'
};
